<template>
  <TrackedCategoriesScreen
    :account-id="accountId"
    direction="incoming"
    i18n-prefix="commercialisation"
  />
</template>

<script lang="ts" setup>
import TrackedCategoriesScreen from "@/views/Account/views/TrackedCategories/TrackedCategoriesScreen.vue";

defineProps<{
  accountId: string;
}>();
</script>
